import { render, staticRenderFns } from "./ViberCampaignCreateRoute.vue?vue&type=template&id=218e922e&scoped=true&"
import script from "./ViberCampaignCreateRoute.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignCreateRoute.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignCreateRoute.vue?vue&type=style&index=0&id=218e922e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e922e",
  null
  
)

export default component.exports